import { FeedFiltersAction } from '../../actions/feed-filters';
import {
    CHANGE_FEED_FILTERS_RATE,
    ChangeFeedFiltersRateAction,
    SET_FEED_FILTER_RATE_FORM_ERRORS,
    SetFeedFilterRateFormErrorsAction,
    UPDATE_FEED_FILTERS_RATE,
    UPDATE_FEED_FILTERS_RATE_RESULT,
    UpdateFeedFiltersRateAction,
    UpdateFeedFiltersRateResultAction
} from '../../actions/feed-filters/rate-form';
import { PageStatus } from '../../typings/common';
import {
    FeedFilterRateType,
    FeedFiltersState
} from '../../typings/feedFilters';

export const RATE_FORM_INITIAL_STATE = {
    rateType: FeedFilterRateType.cpc,
    rate: 0,
    status: PageStatus.LOADED
};

const changeRate = (
    state: FeedFiltersState,
    action: ChangeFeedFiltersRateAction
): FeedFiltersState => {
    return {
        ...state,
        rateForm: {
            ...state.rateForm,
            ...action.payload,
            errors: []
        }
    };
};

const updateRate = (
    state: FeedFiltersState,
    action: UpdateFeedFiltersRateAction
): FeedFiltersState => {
    return {
        ...state,
        rateForm: {
            ...state.rateForm,
            status: PageStatus.LOADING
        }
    };
};

const updateRateResult = (
    state: FeedFiltersState,
    action: UpdateFeedFiltersRateResultAction
): FeedFiltersState => {
    const { status } = action;

    switch (status) {
        case PageStatus.ERROR:
            return {
                ...state,
                rateForm: {
                    ...state.rateForm,
                    status
                }
            };
        default:
            return {
                ...state,
                rateForm: RATE_FORM_INITIAL_STATE
            };
    }
};

const setValidationErrors = (
    state: FeedFiltersState,
    action: SetFeedFilterRateFormErrorsAction
): FeedFiltersState => {
    return {
        ...state,
        rateForm: {
            ...state.rateForm,
            errors: action.errors,
            status: PageStatus.ERROR
        }
    };
};

export const rateFormReducer = (
    state: FeedFiltersState,
    action: FeedFiltersAction
): FeedFiltersState => {
    switch (action.type) {
        case CHANGE_FEED_FILTERS_RATE:
            return changeRate(state, action);
        case UPDATE_FEED_FILTERS_RATE:
            return updateRate(state, action);
        case UPDATE_FEED_FILTERS_RATE_RESULT:
            return updateRateResult(state, action);
        case SET_FEED_FILTER_RATE_FORM_ERRORS:
            return setValidationErrors(state, action);
        default:
            return state;
    }
};
